import { useQuery } from 'react-query';
import { Collection } from '../api';

export function useContributions() {
  const { data } = useQuery('contributions', Collection.contributions);

  return data;
}
